import React from 'react';
import { useContent } from '../../context/ContentContext';
import { resolveWatchSections } from '../../data/watchSections';
import { getWatchSectionIndex, resolveWatchItem } from '../../data/watchVideos';

export default function EditorPanelWatchVideosDetail({ contentKey }) {
  const { getContent, setContentValue } = useContent();
  const sectionIndex = getWatchSectionIndex(contentKey);
  const sections = resolveWatchSections(getContent);
  const section = sectionIndex !== null ? sections[sectionIndex] : null;

  if (!section || sectionIndex === null) return null;

  const saveVideos = (videos) => {
    setContentValue(`watch.section.${sectionIndex}.videos`, videos);
  };

  const updateVideo = (videoIndex, patch) => {
    const videos = [...section.videos];
    const entry = videos[videoIndex];
    if (typeof entry === 'string') {
      if (patch.thumbnail !== undefined) {
        videos[videoIndex] = { url: patch.url ?? entry, thumbnail: patch.thumbnail };
      } else if (patch.url !== undefined) {
        videos[videoIndex] = patch.url;
      }
    } else {
      videos[videoIndex] = { ...entry, ...patch };
    }
    saveVideos(videos);
  };

  const removeVideo = (videoIndex) => {
    saveVideos(section.videos.filter((_, idx) => idx !== videoIndex));
  };

  const addVideo = () => {
    saveVideos([...section.videos, 'https://www.youtube.com/watch?v=']);
  };

  return (
    <div className="editor-panel__detail" onClick={(e) => e.stopPropagation()}>
      <p className="editor-panel__detail-lead">
        Edit {section.title} videos below. Paste a YouTube or Shorts URL for each item.
      </p>

      <ul className="editor-panel__detail-list">
        {section.videos.map((entry, index) => {
          const { url, thumbnail } = resolveWatchItem(entry, section);

          return (
            <li key={`watch-video-${index}`} className="editor-panel__detail-card">
              <div className="editor-panel__detail-card-head">
                <div className="editor-panel__detail-thumb-wrap editor-panel__detail-thumb-wrap--wide">
                  {thumbnail ? (
                    <img src={thumbnail} alt="" className="editor-panel__detail-thumb" />
                  ) : (
                    <span className="editor-panel__detail-thumb-placeholder" aria-hidden="true" />
                  )}
                </div>
                <span className="editor-panel__detail-card-title">Video {index + 1}</span>
              </div>

              <label className="editor-panel__detail-label" htmlFor={`watch-${sectionIndex}-${index}-url`}>
                YouTube URL
              </label>
              <input
                id={`watch-${sectionIndex}-${index}-url`}
                type="url"
                className="editor-panel__detail-input"
                value={url}
                placeholder="https://www.youtube.com/..."
                onChange={(e) => updateVideo(index, { url: e.target.value })}
              />

              <label className="editor-panel__detail-label" htmlFor={`watch-${sectionIndex}-${index}-thumb`}>
                Thumbnail image URL
              </label>
              <input
                id={`watch-${sectionIndex}-${index}-thumb`}
                type="url"
                className="editor-panel__detail-input"
                value={thumbnail}
                placeholder="https://img.youtube.com/vi/.../hqdefault.jpg"
                onChange={(e) => updateVideo(index, { thumbnail: e.target.value })}
              />

              <div className="editor-panel__detail-btn-row">
                <button
                  type="button"
                  className="editor-panel__detail-btn editor-panel__detail-btn--danger"
                  onClick={() => {
                    if (window.confirm('Remove this video?')) removeVideo(index);
                  }}
                >
                  Remove
                </button>
              </div>
            </li>
          );
        })}
      </ul>

      <div className="editor-panel__detail-btn-row editor-panel__detail-btn-row--footer">
        <button type="button" className="editor-panel__detail-btn editor-panel__detail-btn--primary" onClick={addVideo}>
          + Add video
        </button>
      </div>
    </div>
  );
}
